import {ReadonlyDeep} from 'type-fest';
import {WorkerEntity} from '../../../universal/features/api/entity/dashboard/worker/WorkerEntity';

export default (
  workers: readonly ReadonlyDeep<WorkerEntity>[],
  balance: (workerId: string) => number,
): number =>
  workers.reduce((total, worker) => total + balance(worker.id), 0) / 1e12;
